import React from 'react';
import { Container } from 'react-bootstrap';
import Slider from 'react-slick';
import './AchievementSection.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


import logo3 from '../../assets/logo-3.jpg';
import logo4 from '../../assets/1.jpg';
import logo5 from '../../assets/logo-5.jpg';
import logo1 from '../../assets/2.jpg';
import logo6 from '../../assets/3.jpg';
import logo7 from '../../assets/logo-7.jpg';
import logo8 from '../../assets/4.jpg';
import logo9 from '../../assets/5.jpg';

import logo11 from '../../assets/6.jpg';
import logo12 from '../../assets/7.jpg';
import logo13 from '../../assets/8.jpg';
import logo14 from '../../assets/9.jpg';
import logo15 from '../../assets/10.jpg';
import logo16 from '../../assets/11.jpg';
import logo17 from '../../assets/12.jpg';

// ✅ Make sure this is ABOVE your component
const logos = [logo1, logo3, logo4, logo5, logo6, logo7,logo8,logo9,  logo11, logo12, logo13, logo14,logo15,logo16,logo17];

const AchievementSection = () => {
  const settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 1500,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <section className="achievement-section text-center text-white">
      <Container>
        <h1 className="achievement-title">Our Client</h1>
        <div className="achievement-divider mb-3"></div>
       <p className="achievement-description mx-auto mb-4">
  We take pride in our proven track record of executing high-impact events that exceed expectations. Our achievements reflect our commitment to quality, creativity, and client satisfaction.
</p>


        {/* ✅ logos is used here AFTER being declared above */}
        <Slider {...settings}>
          {logos.map((logo, index) => (
            <div key={index} className="logo-slide">
              <img src={logo} alt={`logo-${index}`} className="img-fluid grayscale-logo" />
            </div>
          ))}
        </Slider>
      </Container>
    </section>
  );
};

export default AchievementSection;
